export const i18nMessages = {
  error: {
    title: 'Something went wrong...',
    message: 'Please, try again. If this error persists, feel free to contact Shape team.',
  },
  fetch_error: {
    title: 'Something went wrong...',
    message: 'An error occured. Please, try again or contact support.',
  },
  unauthorized: {
    title: 'Unauthorized',
    message: "You don't have permission for this action",
  },
  model_not_found: {
    title: 'Model was not found.',
    message: 'Please, try again. If this error persists, feel free to contact Shape team.',
  },
  success: {
    title: 'Success!',
    message: 'Operation completed successfully',
  },
  info: {
    title: 'Ok',
    message: 'Operation completed',
  },
  warning: {
    title: 'Warning',
    message: 'Something did not go as expected',
  },
  create: {
    title: 'Success!',
    message: 'New {{item}} created successfully',
  },
  edit: {
    title: 'Success!',
    message: 'Changes applied successfully!',
  },
  delete: { title: 'Success!', message: '{{item}} deleted successfully' },
  conflict: {
    title: 'Ops..',
    message: 'There was a conflict when performing the operation, try again',
  },
  server_error: {
    title: 'Ops..',
    message: 'Internal Server Error',
  },
  validation_error: {
    title: 'Validation Error',
    message:
      'There was a validation error when performing the operation, verify the data and try again',
  },
  auth_error: {
    title: 'Ops..',
    message: 'Authentication error. Please try again in few minutes',
  },
  '404': {
    title: 'Page not found',
    message: 'Please try to going back to the previous page or contact Shape support.',
    action: 'Go to home page',
  },
  new_event_alert: {
    title: 'New Event',
    message: 'The Event {{eventId}} was created for asset {{asset}}',
  },
  form_error: {
    title: 'Ops..',
    message:
      'Sorry, unable to save because some fields are missing or incorrect. Please check the following items below before saving.',
    required: 'is required',
    special_character: 'Special characters are not allowed',
  },
  workspaceError: {
    title: 'Error',
    message: 'Your user does not have a registered workspace',
  },
  no_data: {
    title: 'No data',
    message: 'No data available',
  },
  copied_id_success: {
    message: 'ID copied',
  },
  login_email_error: {
    title: 'Error',
    message: 'This email is not valid or is not registered for this client',
  },
  no_kpi: {
    message: 'No KPI Registered',
  },
  api_errors: {
    403: {
      title: 'Permission Error',
      message: "You don't have permission to access information related to this asset",
    },
  },
  prevent_edit_leave: {
    title: 'Exit without saving?',
    message: 'Some fields on this page have been edited. If you proceed, this data will be lost.',
    confirmLabel: 'Yes, exit',
    cancelLabel: 'Cancel',
  },
};
